import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-0 z-0 select-none text-9xl font-black text-background-200 md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="font-heading text-3xl tracking-[0.24em] text-primary-600 uppercase">Auréa</span>
        <h2 className="mt-6 font-heading text-2xl text-foreground-900 md:text-3xl">
          Não encontramos esta página
        </h2>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 max-w-md text-base text-foreground-600">
          O endereço pode estar incorreto ou a página saiu do ar. Volte para a página inicial e
          continue navegando pelos nossos calçados e acessórios.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" />
          Voltar para o início
        </Link>
      </div>
    </div>
  );
}